import { Schema } from "@comparaonline/products-schema";

export const getLandingName = (product?: Schema.ProductListProduct | null) =>
  product ? `${product.division.name} ${product.name}` : "";
